export default __webpack_public_path__ + "static/pre-matricula-b97102c7f66939c70055b2e69f925145.jpg";